// ============================================================
// /src/domain/margin.ts (MARGINS - JEDYNE DOZWOLONE MIEJSCE)
// ============================================================

import { CostBreakdown } from "./types";

export function applyMargin(
  costs: CostBreakdown,
  confidence: number
): CostBreakdown {
  // Niższa ufność = wyższy margin na ryzyko błędu
  const confidenceMultiplier = confidence < 80 ? 1.25 : 1.15;
  
  return {
    ...costs,
    margin: (costs.materials + costs.labor) * (confidenceMultiplier - 1),
    total: costs.total * confidenceMultiplier
  };
}
